import React from "react"
import { Script } from "gatsby"

function NetPromoterSurvey() {
  if (!process.env.GATSBY_NPS_TOKEN || !process.env.GATSBY_NPS_SETTING) {
    return null
  }

  return (
    <>
      <Script
        src="https://cdn.vitally.io/vitally.js/v1/vitally.js"
        strategy="idle"
      />
      <Script>
        {`
          !function(n,t,r){for(var i=n[t]=n[t]||[],o=function(r){i[r] = i[r] || function () { for (var n = [], t = 0; t < arguments.length; t++)n[t] = arguments[t]; return i.push([r, n]) }},u=0,c=["init","user","account","track","nps"];u<c.length;u++){o(c[u])}}(window,"Vitally");
          Vitally.init('${process.env.GATSBY_NPS_TOKEN}');

        `}
      </Script>
    </>
  )
}

export default NetPromoterSurvey
